/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Team_WaitInputs */

const en_inbox_na_team_wait = /** @type {(inputs: Inbox_Na_Team_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team working…`)
};

const id_inbox_na_team_wait = /** @type {(inputs: Inbox_Na_Team_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim sedang bekerja…`)
};

/**
* | output |
* | --- |
* | "Team working…" |
*
* @param {Inbox_Na_Team_WaitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_team_wait = /** @type {((inputs?: Inbox_Na_Team_WaitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Team_WaitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_team_wait(inputs)
	return en_inbox_na_team_wait(inputs)
});